var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanamon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 657.99 165.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#046148;}.cls-2{fill:#ef9826;}.cls-3{fill:#eb712d;}.cls-4{fill:#fec02b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5563",
    className: "cls-1",
    d: "M15.44,105.49h7.12c4.06,0,7.34.33,11,4.51,2.56,2.88,5.38,9.27,5.38,19.6a59.13,59.13,0,0,1-.68,11.15c-1.12,5.95-3.87,15.49-19.57,15.49-4.21,0-3.21-.11-3.21-.11V105.5ZM23.51,165c21.14,0,30.6-9.43,30.6-35.19,0-6.81-2-18.23-8.34-25.19-6.56-7.15-15-8-22.21-8H0V165Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5565",
    className: "cls-1",
    d: "M90.22,147.32c0,2.26-.06,5.3-2.47,7.48a9.19,9.19,0,0,1-5.93,1.91c-2.68,0-5.1-1-6.11-4.29a12.87,12.87,0,0,1-.36-3.11c0-5,3.32-7.1,7-8a51,51,0,0,1,7.87-.92v6.92Zm0-13.09-7.7.76c-8.3.95-11.47,1.71-15,4.07a13.12,13.12,0,0,0-5.81,11.47c0,4.67,1.42,8.19,3.35,10.21,2.55,3,6.58,4.06,10.48,4.06,9.56,0,14.12-4.34,14.12-4.34l.06,3.08h12.89V131.18c0-3.65.08-8.77-4.1-12.39a12.45,12.45,0,0,0-7-3.16,30.44,30.44,0,0,0-6.83-.74c-8.69,0-15.25,1.53-19,8.18-1.6,2.88-1.52,5.77-1.52,8H75.92c.1-1.93.19-4.6,1.7-6.45.76-1.06,2.54-2.56,5.85-2.56,1.08,0,4.21,0,5.8,2.61.89,1.54,1,3.54,1,5.81v3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5567",
    className: "cls-1",
    d: "M192.8,147.32c0,2.26-.07,5.3-2.49,7.48-2,1.78-4.81,1.91-6,1.91-2.66,0-5-1-6.07-4.29a12.81,12.81,0,0,1-.33-3.11c0-5,3.29-7.1,7-8a50.66,50.66,0,0,1,7.85-.92v6.92Zm0-13.09-7.67.76c-8.35.95-11.48,1.71-15,4.07a13.19,13.19,0,0,0-5.79,11.47c0,4.67,1.38,8.19,3.29,10.21,2.58,3,6.64,4.06,10.52,4.06,9.58,0,14.13-4.34,14.13-4.34l.07,3.08h12.83V131.18c0-3.65.11-8.77-4-12.39a12.6,12.6,0,0,0-7.06-3.16,30.49,30.49,0,0,0-6.85-.74c-8.68,0-15.23,1.53-19,8.18-1.59,2.88-1.48,5.77-1.48,8H178.5c.1-1.93.19-4.6,1.7-6.45.75-1.06,2.54-2.56,5.85-2.56,1.08,0,4.2,0,5.84,2.61.84,1.54.92,3.54.92,5.81v3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5569",
    className: "cls-1",
    d: "M386.91,163.54H373.46v-29c0-1.85,0-3.39-.15-5s-.56-6.44-6.43-6.44a9.62,9.62,0,0,0-3.71.75c-4,1.81-4.06,5-4.16,7.59v32H345.54v-47.4H359v5.39c3.39-3,6.45-6.34,14-6.34,6.35,0,9.5,2.46,10.8,4,3,3.36,3,7.72,3.1,11.12v33.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5571",
    className: "cls-1",
    d: "M154.4,163.54H141v-29a35.59,35.59,0,0,0-.22-5c-.09-1.52-.55-6.44-6.44-6.44a9.56,9.56,0,0,0-3.66.75c-4,1.81-4.09,5-4.2,7.59v32H113v-47.4h13.46v5.39c3.45-3,6.47-6.34,14-6.34,6.39,0,9.48,2.46,10.81,4,3,3.36,3,7.72,3.13,11.12v33.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5573",
    className: "cls-1",
    d: "M215,116.12h13.46v5.51c2.58-2.31,7.14-6.49,15.22-6.49,9.25,0,11.82,5.52,12.45,7.35,5.51-5.33,9.13-7.35,14.4-7.35a16.67,16.67,0,0,1,6.07,1c7.24,2.78,7.4,9.23,7.54,13.41v33.91h-13.7V132.62c-.06-3.36-.17-5.26-1-6.74a5.3,5.3,0,0,0-4.92-2.75,11.64,11.64,0,0,0-4.37.84c-3.77,1.8-3.92,4.93-4,7.47v32.07H242.8V132.82c0-3.65,0-9.69-6-9.69a12.71,12.71,0,0,0-4.94,1c-3.35,2.06-3.44,5.09-3.35,9.31v30H215V116.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5575",
    className: "cls-1",
    d: "M323.89,138.82a73.21,73.21,0,0,1-.39,7.88c-.28,2.62-.74,7.88-4.77,10.09a8.42,8.42,0,0,1-3.63.84c-7.64,0-8.33-8-8.48-10.93-.18-2.18-.31-4.32-.31-6.44,0-1.9.13-4.53.4-7.64.28-2.51.84-7.31,4.72-9.58a8.66,8.66,0,0,1,4.09-1c7.24,0,7.9,7.6,8.07,10.53.19,2.08.3,4.17.3,6.2m13.72.24c0-4.21,0-12.08-4.67-17.43-5.65-6.74-13.73-6.74-16.59-6.74-3.32,0-11,.13-17,5.57-6.77,6-6.77,15.69-6.77,20.57,0,9.27,2.09,19.06,13.81,22.48a24.84,24.84,0,0,0,8.65,1.23c3.22,0,11.25,0,17.22-6.64,5.3-5.87,5.3-14.67,5.3-19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5581",
    className: "cls-2",
    d: "M104.12,48.33H228.64L118.2,14.46,104.12,22,56.32,34.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5577",
    className: "cls-3",
    d: "M0,0V48.33H104.13V22L0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5579",
    className: "cls-4",
    d: "M228.7,48.33,104.12,0l0,22L228.7,48.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5585",
    className: "cls-2",
    d: "M658,139.18V48.3H490.27L455.4,73.43l34.87,30.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5587",
    className: "cls-4",
    d: "M490.26,103.72,444.67,64.41l-216-16,261.55,90.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5583",
    className: "cls-3",
    d: "M228.66,48.3v0l261.6,55.36V48.31H228.66Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanamon);
export default __webpack_public_path__ + "static/media/danamon.a5164a4c2fbd0606c37132236c0c8e2a.svg";
export { ForwardRef as ReactComponent };